import { CodeToText } from 'element-china-area-data'
//将13位时间戳转换xxx-xx-xx日期
let formatDate = (timestamp, type) => {
        if (timestamp) {
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear();
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
            let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
            let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
            let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            if (type == '1') {
                var datess = Y + '-' + M + '-' + D;
            } else if (type == '2') {
                var datess = M + '-' + D + " " + h + ':' + m + ':' + s;
            } else if (type == '3') {
                var datess = M + '-' + D + " " + h + ':' + m;
            } else if (type == '4') {
                var datess = Y + '-' + M + '-' + D + " " + h + ':' + m;
            } else if (type == '5') {
                var datess = Y + '-' + M + '-' + D + " " + h + ':' + m + ':' + s;
            } else {
                var datess = Y + '-' + M + '-' + D;
            }

            return datess;
        }
    }
    //将13位时间戳转换xxx-xx-xx日期
let formatDateTime = timestamp => {
        let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' ';
        let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        let datess = Y + M + D + " " + h + m + s;
        return datess;
    }
    // 将系统返回的来的13时间戳计算出距离当前时间的时间间隔，xx分钟前，xx小时前，天，月。。。前
let timeDiff = (dateTimeStamp) => {
    //  if (type == 1) {
    //      var stringTime = new Date(Date.parse(dateTimeStamp.replace(/-/g, "/")));
    //      dateTimeStamp = stringTime.getTime();
    //  }
    // dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
    if (dateTimeStamp == null) {
        return "";
    }
    var type = ""; //前 或者 后
    var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime(); //获取当前时间毫秒
    var diffValue = now - dateTimeStamp; //时间差
    if (diffValue < 0) {
        type = "后"
        diffValue = 0 - diffValue
    } else {
        type = "前"
    }
    var minC = diffValue / minute; //计算时间差的分，时，天，周，月
    var hourC = diffValue / hour;
    var dayC = diffValue / day;
    var weekC = diffValue / week;
    var monthC = diffValue / month;
    var result = '';
    if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月" + type;
    } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周" + type;
    } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天" + type;
    } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时" + type;
    } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟" + type;
    } else
        result = "刚刚";
    return result;
}

let timeWarn = (dateTimeStamp, opt) => {
    //  if (type == 1) {
    //      var stringTime = new Date(Date.parse(dateTimeStamp.replace(/-/g, "/")));
    //      dateTimeStamp = stringTime.getTime();
    //  }
    // dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
    if (dateTimeStamp == null) {
        return "";
    }
    if (!Array.isArray(opt)) {
        return "";
    }
    let now = new Date().getTime()
        //相差的天数
    let diff = (dateTimeStamp - now) / 1000 / 60 / 60 / 24
    for (let i = 0; i < opt.length; i++) {
        let ob = opt[i]
        if (ob.deadline >= diff) {
            return ob.cssStr
        }
    }
    return "";
}

// 过滤金额，保留两位小数
let ToFixed = num => {
    // return Math.floor(num * 100) / 100;  有bug,当xx.0000 时，return xx 
    if (num == null) {
        return "0.00";
    } else if (num.indexOf(".") == -1) {
        return num;
    } else {
        let indexLength = num.indexOf(".") + 3;
        return num.substr(0, indexLength);
    }

}

let textareaToBr = val => {
    // return Math.floor(num * 100) / 100;  有bug,当xx.0000 时，return xx 
    if (val == null || typeof val != "string" || val == "") {
        return "";
    }
    return val.replace(/\n/g, "<p>")

}

let spaceFormat = (val, type) => {
    if (type == null || type == '') {
        return null;
    }
    if (val == null || val == '') {
        return '0' + type.toUpperCase();
    }
    if (!isNumber(val)) {
        return ""
    }
    if (type.toLowerCase() == 'b') {
        if (val >= 1024) {
            return spaceFormat(val / 1024, 'KB')
        } else {
            return toDecimal2NoZero(val) + 'B'
        }
    } else if (type.toLowerCase() == 'kb') {
        if (val >= 1024) {
            return spaceFormat(val / 1024, 'MB')
        } else {
            return toDecimal2NoZero(val) + 'KB'
        }
    } else if (type.toLowerCase() == 'mb') {
        if (val >= 1024) {
            return spaceFormat(val / 1024, 'GB')
        } else {
            return toDecimal2NoZero(val) + 'MB'
        }
    } else {
        return toDecimal2NoZero(val) + 'GB'
    }
}

let percentFormat = (val) => {
    if (!isNumber(val)) {
        return ""
    }
    return toDecimal2NoZero(val) + '%'
}

let toDecimal2NoZero = (x) => {
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    return s;
}

let nullForString = (v, props) => {
    if (v == null) {
        return "";
    }
    if (typeof v === "string") {
        return v;
    }
    if (Array.isArray(v)) {
        v=v[0]
    }
    if (Array.isArray(props)) {
        var prop = props.shift()
        if (props.length == 0) {
            return v[prop]
        }
        return nullForString(v[prop], props)
    } else if (typeof props === "string") {
        return v[props] == null ? '' : v[props]
    }
}
let yesNo = (state) => {
    if (state == '0') {
        return "否";
    }
    if (state == '1') {
        return "是";
    }
}
let logTypeName = (type) => {
    if (type == '1') {
        return "登录";
    }
    if (type == '2') {
        return "登出";
    }
    if (type == '3') {
        return "其他";
    }
}

function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}

let findByList = (value, listObj) => {
    let defaultValue = ""
    let list = listObj.list
    let keyName = listObj.keyName
    let valueName = listObj.valueName
    if (list == null || !Array.isArray(list) || keyName == null || valueName == null) {
        return defaultValue;
    }
    list.forEach(element => {
        if(element[keyName] == value){
            defaultValue = element[valueName]
            return true
        }
    });
    return defaultValue;
}

let areaNameFormat = (adCode) => {
    let areaName=""
    let areatmp = []
    if(!adCode){
        return areaName
    }
    let arr = adCode.split('/')
    arr.forEach(elem => {
        areatmp.push(CodeToText[elem])
    });
    areaName = areatmp.join('/')
    return areaName;
}

export { formatDate, formatDateTime, timeDiff, ToFixed, textareaToBr, spaceFormat, percentFormat, nullForString, timeWarn, yesNo, logTypeName,findByList,areaNameFormat }


// WEBPACK FOOTER //
// ./src/assets/js/filter.js